import React from 'react'

const MapContext = React.createContext()

const withMap = Component => props => (
  <MapContext.Consumer>
    {context => <Component map={context} {...props} />}
  </MapContext.Consumer>
)

export {
  withMap,
  MapContext,
}



// WEBPACK FOOTER //
// ./src/components/library/widgets/map/components/MapContext.js